import type React from 'react'
import {useCallback, useState} from 'react'

function usePipelineParameterForm(
  parameterName: string,
  parameterValue: string,
  onConfirm: (name: string, value: string) => void,
) {
  const [isFormInvalid, setFormInvalid] = useState<boolean>(false)
  const [fieldName, setFieldName] = useState<string>(parameterName)
  const [fieldValue, setFieldValue] = useState<string>(parameterValue)
  const confirmButtonClickHandler = () => onConfirm(fieldName, fieldValue)
  const keyPressInputFormHandler = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'Enter' && !isFormInvalid) {
        event.preventDefault()
        onConfirm(fieldName, fieldValue)
      }
    },
    [onConfirm, fieldName, fieldValue, isFormInvalid],
  )
  const validFormFieldsetHandler = (state: boolean) => setFormInvalid(!state)
  const changeFormFieldsetHandler = (name: string, value: string) => {
    setFieldName(name)
    setFieldValue(value)
  }

  return {
    fieldName,
    fieldValue,
    isFormInvalid,
    keyPressInputFormHandler,
    confirmButtonClickHandler,
    changeFormFieldsetHandler,
    validFormFieldsetHandler,
  }
}

export default usePipelineParameterForm
